import React from 'react'
import MaterialTable from 'material-table';
import { darken, makeStyles, Paper } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { COLORS_PROJECT } from '../../constants';
import { Title } from '../ui/Title';



const {color_enc_table,color_nav_letter_enc_table,color_background_tables}= COLORS_PROJECT; //color_nav,color_nav_letter,
const useStyles = makeStyles(()=>({
    
    paper: {  
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },

}))

export const ReportAlarmTables = () => {
    const classes = useStyles();
    const {data} = useSelector(state => state.print);
    
    let {
        1:red_alert={alerta_roja_mayor:[]},
        0:general_characteristic,
    }= data;

    if (red_alert===null) {
        red_alert=[]
    }
    const {alerta_roja_mayor}=red_alert

    
 
    
    return (
        <>
            <Paper className={classes.paper}>
                <MaterialTable
                    title = {<Title color="#ffffff">Alerta riesgo máximo mayor duración</Title>}
                    columns = {[
                        {
                            field: 'fecha_on', 
                            title: 'Fecha',
                            render: rowData => (
                                rowData.fecha_on.substr(0,10)
                            ),
                        },
                        {
                            field: 'fecha_on', 
                            title: 'Hora Inicio',
                            render: rowData => (
                                rowData.fecha_on.substr(10,6)
                            ),
                        },
                        {
                            field: 'fecha_off', 
                            title: 'Hora Fin',
                            render: rowData => (
                                rowData.fecha_off.substr(10,6)
                            ),
                        },
                        {
                            field: 'duracion', 
                            title: 'Duración [hh:mm]',
                            render: rowData => (
                                rowData.duracion.substr(0,5)
                            ),
                        },
                    ]}
                    data={alerta_roja_mayor}
                    options={{
                        paging: false,
                        search: false,
                        headerStyle: {
                            backgroundColor: darken(color_enc_table,0.2),
                            color: color_nav_letter_enc_table,
                            paddingRight: 0,
                            paddingLeft: 5,
                            fontWeight: 'bold',
                        },
                        rowStyle: {backgroundColor: color_background_tables},

                    
                    }}

                />
            </Paper>
            
                
            
            <Paper className={classes.paper} style = {{marginTop: '45px'}}>
                <MaterialTable 
                    title = {<Title color="#ffffff">Días con Alertas</Title>}
                    columns = {[
                        {
                            field: 'dias', 
                            title: 'Titulo',
                            render: rowData =>{
                                if(!rowData.dias){
                                    return 'Días'
                                }
                            }
                        }, 
                        {
                            field: 'dias_alertados', 
                            title: 'Numero',
                        }, 
                        
                    ]}
                    data={general_characteristic}
                    options={{
                        paging: false,
                        search: false,
                        header: false,
                        rowStyle: {backgroundColor: color_background_tables}
                    }}
                />
            </Paper>     
        </>
    )
}
